'use client'

import Link from 'next/link'
import Container from './Container'
import { IconBrandNpm } from '@tabler/icons-react'

export default function Navbar() {
  return (
    <nav className="bg-white border-b border-[#E5E5E5]">
      <Container>
        <div className="flex items-center justify-between h-16">
          <Link href="/" className="flex items-center gap-2">
            <IconBrandNpm size={32} className="text-[#0066CC]" />
            <span className="text-xl font-semibold">NPM Star</span>
          </Link>
          
          <div className="flex items-center gap-6">
            <Link 
              href="/collections" 
              className="text-[#333333] hover:text-[#0066CC]"
            >
              Collections
            </Link>
            
          </div>
        </div>
      </Container>
    </nav>
  )
} 